module.exports = __webpack_public_path__ + "img/矩形 2630.059b1956.png";